import { ChevronRight } from "@winamp/icons/ChevronRight.js";
import { classNames } from "../../utils/classNames";

export function BreadcrumbSeparator({
  children,
  className,
  ...props
}: React.ComponentProps<"li">) {
  return (
    <li
      role="presentation"
      aria-hidden="true"
      className={classNames("[&>svg]:size-4 text-primary", className)}
      {...props}
    >
      {children ?? <ChevronRight />}
    </li>
  );
}
